import { Link } from 'react-router-dom';
import type { HotEvent } from '@/mocks/events';
import { StatusBadge, CategoryTag } from '@/components/feature/EventBits';

export default function EventRow({ event }: { event: HotEvent }) {
  const first = event.nodes[0];
  return (
    <Link
      to={`/event/${event.id}`}
      className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-all hover:border-primary-200 hover:bg-background-50 sm:flex-row md:gap-5"
    >
      <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-lg bg-background-100 sm:h-40 sm:w-60 md:w-64">
        <img src={event.cover} alt={event.coverAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute bottom-2 left-2 rounded bg-foreground-950/60 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm tabular-nums">
          爆发 {first.date.slice(5).replace('-', '/')}
        </span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col py-1">
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge status={event.status} />
          <CategoryTag category={event.category} />
          <span className="text-xs text-foreground-400">
            {event.tags.slice(0, 2).map((t) => `#${t}`).join(' ')}
          </span>
        </div>
        <h3 className="mt-2.5 line-clamp-1 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {event.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{event.summary}</p>
        <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1"><i className="ri-node-tree text-primary-500" /> {event.nodes.length} 个节点</span>
          <span className="flex items-center gap-1"><i className="ri-fire-line text-accent-500" /> 热度 {event.heat}</span>
          <span className="hidden items-center gap-1 sm:flex"><i className="ri-refresh-line" /> 更新 {event.updated.slice(5).replace('-', '/')}</span>
        </div>
        {event.followText && (
          <p className="mt-2 flex items-start gap-1.5 rounded-md bg-secondary-100/70 px-2.5 py-1.5 text-xs text-secondary-800">
            <i className="mt-0.5 ri-live-line" />
            <span className="line-clamp-1">{event.followText}</span>
          </p>
        )}
      </div>

      <div className="hidden shrink-0 flex-col items-center justify-center gap-2 border-l border-background-200 pl-4 pr-2 md:flex">
        <span className="text-xs text-foreground-400">进展</span>
        <span className="text-2xl font-semibold text-primary-600 tabular-nums">{event.nodes.length}</span>
        <i className="text-lg text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500 ri-arrow-right-line" />
      </div>
    </Link>
  );
}